/**
 * Where a new link goes: a web page, email address or phone number, or a
 * page of this document.
 */

import { useState } from 'react'

interface Props {
  pageCount: number
  current: number
  onSubmit: (target: { uri: string } | { targetPage: number }) => void
  onCancel: () => void
}

export function LinkDialog({ pageCount, current, onSubmit, onCancel }: Props) {
  const [kind, setKind] = useState<'web' | 'page'>('web')
  const [uri, setUri] = useState('')
  const [page, setPage] = useState(String(Math.min(current + 2, pageCount)))
  const pageNumber = Number(page)
  const valid = kind === 'web'
    ? uri.trim().length > 0
    : Number.isInteger(pageNumber) && pageNumber >= 1 && pageNumber <= pageCount

  return (
    <div className="modal" role="dialog" aria-modal="true" aria-labelledby="link-title">
      <form
        className="modal__panel"
        onSubmit={(event) => {
          event.preventDefault()
          if (!valid) return
          onSubmit(kind === 'web' ? { uri: uri.trim() } : { targetPage: pageNumber - 1 })
        }}
      >
        <h2 className="modal__title" id="link-title">Add link</h2>
        <div className="modal__body">
          <label className="check">
            <input type="radio" name="link-kind" checked={kind === 'web'} onChange={() => setKind('web')} />
            A web page, email address or phone number
          </label>
          {kind === 'web' && (
            <label className="field">
              <span>Address</span>
              <input autoFocus value={uri} placeholder="https://www.swiftcurrent.ca  or  clerk@swiftcurrent.ca"
                     onChange={(e) => setUri(e.target.value)} />
            </label>
          )}
          <label className="check">
            <input type="radio" name="link-kind" checked={kind === 'page'} onChange={() => setKind('page')} />
            A page in this document
          </label>
          {kind === 'page' && (
            <label className="field">
              <span>Page (1&ndash;{pageCount})</span>
              <input type="number" min={1} max={pageCount} value={page} autoFocus
                     onChange={(e) => setPage(e.target.value)} />
            </label>
          )}
          <p className="modal__hint">
            The link is invisible, as Word&rsquo;s are: it covers the area you drew.
            Readers click it in any PDF viewer; in Odie, Ctrl+click it over text.
          </p>
        </div>
        <div className="modal__footer">
          <button type="button" className="btn" onClick={onCancel}>Cancel</button>
          <button type="submit" className="btn btn--primary" disabled={!valid}>Add link</button>
        </div>
      </form>
    </div>
  )
}
